import { useState, useEffect } from "react";
import LoaderWithBackdrop from "../../loader/LoaderWithBackdrop";
import { s3baseUri } from "../../../config/config";

function OneImagePreview({
  imagesList,
  maxHeight,
  checkImagesWiderThanTall,
  imageTag,
}) {
  const [isWiderImage, setIsWiderImage] = useState(null);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    const checkImages = async () => {
      const result = await checkImagesWiderThanTall(1, maxHeight);
      setIsWiderImage(result);
    };

    checkImages();
  }, [imagesList]);

  const getDominantColor = (imageSrc, callback) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src =
      imageSrc?.type === "file"
        ? URL.createObjectURL(imageSrc?.path)
        : imageSrc?.path?.startsWith("data:image")
        ? imageSrc?.path
        : s3baseUri + imageSrc?.thumbnail_1;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);

      const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
      let r = 0,
        g = 0,
        b = 0,
        count = 0;

      for (let i = 0; i < imageData.length; i += 4 * 100) {
        r += imageData[i];
        g += imageData[i + 1];
        b += imageData[i + 2];
        count++;
      }

      // Get average color
      r = Math.floor(r / count);
      g = Math.floor(g / count);
      b = Math.floor(b / count);

      // Blend with white to lighten (70% original color, 30% white)
      const lightenFactor = 0.7;
      r = Math.floor(r * lightenFactor + 255 * (1 - lightenFactor));
      g = Math.floor(g * lightenFactor + 255 * (1 - lightenFactor));
      b = Math.floor(b * lightenFactor + 255 * (1 - lightenFactor));

      callback(`rgb(${r}, ${g}, ${b})`);
    };

    img.onerror = () => {
      callback("#ddd");
    };
  };

  useEffect(() => {
    imagesList.forEach((src, index) => {
      getDominantColor(src, (color) => {
        setColors((prevColors) => [color]);
      });
    });
  }, [imagesList]);

  return (
    <>
      {imagesList.map((image, index) => {
        return (
          <>
            <div
              style={{
                minHeight: `${
                  isWiderImage === null ? `calc(${maxHeight} / 2)` : ""
                }`,
                overflow: "hidden",
                maxHeight: `calc(${maxHeight} - 1rem)`,
                // backgroundColor: colors[index] || "#f0f0f0",
                backgroundColor: "#FFFFFF",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                borderBottomLeftRadius: "inherit",
                borderBottomRightRadius: "inherit",
              }}
              className="d-flex align-items-center justify-content-center position-relative"
            >
              {isWiderImage === null && (
                <>
                  <LoaderWithBackdrop isAbsolute={true} />
                </>
              )}
              {imageTag(image, 0, isWiderImage, true)}
            </div>
          </>
        );
      })}
    </>
  );
}

export default OneImagePreview;
